import { render, staticRenderFns } from "./criteria-additional-interests.vue?vue&type=template&id=77bb8a4f&scoped=true&"
import script from "./criteria-additional-interests.vue?vue&type=script&lang=ts&"
export * from "./criteria-additional-interests.vue?vue&type=script&lang=ts&"
import style0 from "./criteria-additional-interests.vue?vue&type=style&index=0&id=77bb8a4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bb8a4f",
  null
  
)

export default component.exports